/**
 * コンポーネントのz-index値
 */
export default {
  canvas: 2,
  homeLink: 10,
  propertyInformation: 10,
  header: 10,
  textureSelectModalBtn: 10,
  ViewerRotateNav: 10,
  cameraItems: 10,
  modal: 100,
  headerNav: 10,
  footerNav: 10,
  roomLabel: 10,
  galleryDrawerMenu: 20,
  galleryList: 30,
  madoriNode: 5,
  errorModal: 200,
  loading: 150
};
